module.exports=[
  {
    "id": "49391",
    "date": "3/10/2020",
    "test": false,
    "state": "WA",
    "eevp": 100,
    "party": "Dem",
    "type": "Primary",
    "office": "P",
    "results": [
      {
        "fips": "53001",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 3,
        "reporting": 1,
        "reportingPercentage": 33.33,
        "total": 833,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 284,
            "percentage": 34.09
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 288,
            "percentage": 34.57
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 120,
            "percentage": 14.41
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 57,
            "percentage": 6.84
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 25,
            "percentage": 3
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 22,
            "percentage": 2.64
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 11,
            "percentage": 1.32
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 7,
            "percentage": 0.84
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 6,
            "percentage": 0.72
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 5,
            "percentage": 0.6
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 5,
            "percentage": 0.6
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 2,
            "percentage": 0.24
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 1,
            "percentage": 0.12
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53003",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 7,
        "reporting": 6,
        "reportingPercentage": 85.71,
        "total": 2798,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 1118,
            "percentage": 39.96
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 705,
            "percentage": 25.2
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 401,
            "percentage": 14.33
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 198,
            "percentage": 7.08
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 173,
            "percentage": 6.18
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 90,
            "percentage": 3.22
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 36,
            "percentage": 1.29
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 27,
            "percentage": 0.96
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 19,
            "percentage": 0.68
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 18,
            "percentage": 0.64
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 4,
            "percentage": 0.14
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 4,
            "percentage": 0.14
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 3,
            "percentage": 0.11
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 2,
            "percentage": 0.07
          }
        ]
      },
      {
        "fips": "53005",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 50,
        "reporting": 47,
        "reportingPercentage": 94,
        "total": 21769,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 8504,
            "percentage": 39.06
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 6911,
            "percentage": 31.75
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 2258,
            "percentage": 10.37
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 1586,
            "percentage": 7.29
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 1133,
            "percentage": 5.2
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 598,
            "percentage": 2.75
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 322,
            "percentage": 1.48
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 158,
            "percentage": 0.73
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 117,
            "percentage": 0.54
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 84,
            "percentage": 0.39
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 39,
            "percentage": 0.18
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 30,
            "percentage": 0.14
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 19,
            "percentage": 0.09
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 10,
            "percentage": 0.05
          }
        ]
      },
      {
        "fips": "53007",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 21,
        "reporting": 21,
        "reportingPercentage": 100,
        "total": 12284,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 4727,
            "percentage": 38.48
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 4075,
            "percentage": 33.17
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 1164,
            "percentage": 9.48
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 968,
            "percentage": 7.88
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 654,
            "percentage": 5.32
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 358,
            "percentage": 2.91
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 131,
            "percentage": 1.07
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 63,
            "percentage": 0.51
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 50,
            "percentage": 0.41
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 46,
            "percentage": 0.37
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 28,
            "percentage": 0.23
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 12,
            "percentage": 0.1
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 5,
            "percentage": 0.04
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 3,
            "percentage": 0.02
          }
        ]
      },
      {
        "fips": "53009",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 24,
        "reporting": 24,
        "reportingPercentage": 100,
        "total": 18341,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 7124,
            "percentage": 38.84
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 5486,
            "percentage": 29.91
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 1897,
            "percentage": 10.34
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 1773,
            "percentage": 9.67
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 910,
            "percentage": 4.96
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 626,
            "percentage": 3.41
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 218,
            "percentage": 1.19
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 114,
            "percentage": 0.62
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 65,
            "percentage": 0.35
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 63,
            "percentage": 0.34
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 31,
            "percentage": 0.17
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 17,
            "percentage": 0.09
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 9,
            "percentage": 0.05
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 8,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53011",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 125,
        "reporting": 118,
        "reportingPercentage": 94.4,
        "total": 85548,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 32329,
            "percentage": 37.79
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 30067,
            "percentage": 35.15
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 8271,
            "percentage": 9.67
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 6696,
            "percentage": 7.83
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 4322,
            "percentage": 5.05
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 1793,
            "percentage": 2.1
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 860,
            "percentage": 1.01
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 368,
            "percentage": 0.43
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 323,
            "percentage": 0.38
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 250,
            "percentage": 0.29
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 135,
            "percentage": 0.16
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 66,
            "percentage": 0.08
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 35,
            "percentage": 0.04
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 33,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53013",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 2,
        "reporting": 2,
        "reportingPercentage": 100,
        "total": 497,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 189,
            "percentage": 38.03
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 135,
            "percentage": 27.16
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 69,
            "percentage": 13.88
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 34,
            "percentage": 6.84
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 26,
            "percentage": 5.23
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 23,
            "percentage": 4.63
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 8,
            "percentage": 1.61
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 4,
            "percentage": 0.8
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 2,
            "percentage": 0.4
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 2,
            "percentage": 0.4
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 2,
            "percentage": 0.4
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 2,
            "percentage": 0.4
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 1,
            "percentage": 0.2
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53015",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 30,
        "reporting": 27,
        "reportingPercentage": 90,
        "total": 16090,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 6415,
            "percentage": 39.87
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 4894,
            "percentage": 30.42
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 2082,
            "percentage": 12.94
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 1054,
            "percentage": 6.55
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 745,
            "percentage": 4.63
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 339,
            "percentage": 2.11
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 185,
            "percentage": 1.15
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 119,
            "percentage": 0.74
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 93,
            "percentage": 0.58
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 84,
            "percentage": 0.52
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 45,
            "percentage": 0.28
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 15,
            "percentage": 0.09
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 10,
            "percentage": 0.06
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 10,
            "percentage": 0.06
          }
        ]
      },
      {
        "fips": "53017",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 10,
        "reporting": 8,
        "reportingPercentage": 80,
        "total": 4406,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 1799,
            "percentage": 40.83
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 1397,
            "percentage": 31.71
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 474,
            "percentage": 10.76
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 278,
            "percentage": 6.31
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 231,
            "percentage": 5.24
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 102,
            "percentage": 2.32
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 47,
            "percentage": 1.07
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 22,
            "percentage": 0.5
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 19,
            "percentage": 0.43
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 15,
            "percentage": 0.34
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 10,
            "percentage": 0.23
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 7,
            "percentage": 0.16
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 4,
            "percentage": 0.09
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 1,
            "percentage": 0.02
          }
        ]
      },
      {
        "fips": "53019",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 2,
        "reporting": 1,
        "reportingPercentage": 50,
        "total": 937,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 292,
            "percentage": 31.16
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 337,
            "percentage": 35.97
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 123,
            "percentage": 13.13
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 73,
            "percentage": 7.79
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 50,
            "percentage": 5.34
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 31,
            "percentage": 3.31
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 14,
            "percentage": 1.49
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 11,
            "percentage": 1.17
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 3,
            "percentage": 0.32
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 2,
            "percentage": 0.21
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 1,
            "percentage": 0.11
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53021",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 15,
        "reporting": 14,
        "reportingPercentage": 93.33,
        "total": 6874,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 2413,
            "percentage": 35.1
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2751,
            "percentage": 40.02
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 711,
            "percentage": 10.34
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 391,
            "percentage": 5.69
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 247,
            "percentage": 3.59
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 143,
            "percentage": 2.08
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 79,
            "percentage": 1.15
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 39,
            "percentage": 0.57
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 31,
            "percentage": 0.45
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 26,
            "percentage": 0.38
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 21,
            "percentage": 0.31
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 11,
            "percentage": 0.16
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 8,
            "percentage": 0.12
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 3,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53023",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 2,
        "reporting": 1,
        "reportingPercentage": 50,
        "total": 263,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 106,
            "percentage": 40.3
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 62,
            "percentage": 23.57
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 29,
            "percentage": 11.03
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 26,
            "percentage": 9.89
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 20,
            "percentage": 7.6
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 13,
            "percentage": 4.94
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 4,
            "percentage": 1.52
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 2,
            "percentage": 0.76
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 1,
            "percentage": 0.38
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 0,
            "percentage": 0
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53025",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 19,
        "reporting": 18,
        "reportingPercentage": 94.74,
        "total": 6743,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 2254,
            "percentage": 33.43
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2246,
            "percentage": 33.31
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 949,
            "percentage": 14.07
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 438,
            "percentage": 6.5
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 380,
            "percentage": 5.64
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 213,
            "percentage": 3.16
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 91,
            "percentage": 1.35
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 57,
            "percentage": 0.85
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 35,
            "percentage": 0.52
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 34,
            "percentage": 0.5
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 23,
            "percentage": 0.34
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 17,
            "percentage": 0.25
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 4,
            "percentage": 0.06
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 2,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53027",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 20,
        "reporting": 17,
        "reportingPercentage": 85,
        "total": 10556,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 3719,
            "percentage": 35.23
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 3436,
            "percentage": 32.55
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 1396,
            "percentage": 13.22
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 801,
            "percentage": 7.59
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 602,
            "percentage": 5.7
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 287,
            "percentage": 2.72
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 97,
            "percentage": 0.92
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 65,
            "percentage": 0.62
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 58,
            "percentage": 0.55
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 47,
            "percentage": 0.45
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 23,
            "percentage": 0.22
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 13,
            "percentage": 0.12
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 8,
            "percentage": 0.08
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 4,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53029",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 24,
        "reporting": 24,
        "reportingPercentage": 100,
        "total": 20510,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 8239,
            "percentage": 40.17
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 6111,
            "percentage": 29.8
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 1963,
            "percentage": 9.57
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 1860,
            "percentage": 9.07
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 1074,
            "percentage": 5.24
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 749,
            "percentage": 3.65
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 225,
            "percentage": 1.1
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 114,
            "percentage": 0.56
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 68,
            "percentage": 0.33
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 59,
            "percentage": 0.29
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 17,
            "percentage": 0.08
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 13,
            "percentage": 0.06
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 10,
            "percentage": 0.05
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 8,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53031",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 12,
        "reporting": 12,
        "reportingPercentage": 100,
        "total": 13401,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 4907,
            "percentage": 36.62
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 4983,
            "percentage": 37.18
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 1456,
            "percentage": 10.86
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 923,
            "percentage": 6.89
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 469,
            "percentage": 3.5
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 382,
            "percentage": 2.85
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 108,
            "percentage": 0.81
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 84,
            "percentage": 0.63
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 30,
            "percentage": 0.22
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 27,
            "percentage": 0.2
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 11,
            "percentage": 0.08
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 11,
            "percentage": 0.08
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 6,
            "percentage": 0.04
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 4,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53033",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 595,
        "reporting": 595,
        "reportingPercentage": 100,
        "total": 609207,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 232477,
            "percentage": 38.16
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 230245,
            "percentage": 37.79
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 66794,
            "percentage": 10.96
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 36741,
            "percentage": 6.03
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 21202,
            "percentage": 3.48
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 12095,
            "percentage": 1.99
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 3679,
            "percentage": 0.6
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 2351,
            "percentage": 0.39
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 1530,
            "percentage": 0.25
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 804,
            "percentage": 0.13
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 558,
            "percentage": 0.09
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 456,
            "percentage": 0.07
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 147,
            "percentage": 0.02
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 128,
            "percentage": 0.02
          }
        ]
      },
      {
        "fips": "53035",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 79,
        "reporting": 79,
        "reportingPercentage": 100,
        "total": 60876,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 23736,
            "percentage": 38.99
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 19777,
            "percentage": 32.49
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 5661,
            "percentage": 9.3
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 5347,
            "percentage": 8.78
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 3151,
            "percentage": 5.18
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 1706,
            "percentage": 2.8
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 587,
            "percentage": 0.96
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 336,
            "percentage": 0.55
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 253,
            "percentage": 0.42
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 175,
            "percentage": 0.29
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 64,
            "percentage": 0.11
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 43,
            "percentage": 0.07
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 21,
            "percentage": 0.03
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 19,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53037",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 11,
        "reporting": 10,
        "reportingPercentage": 90.91,
        "total": 6532,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 2252,
            "percentage": 34.48
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2331,
            "percentage": 35.69
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 633,
            "percentage": 9.69
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 575,
            "percentage": 8.8
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 320,
            "percentage": 4.9
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 217,
            "percentage": 3.32
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 92,
            "percentage": 1.41
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 37,
            "percentage": 0.57
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 27,
            "percentage": 0.41
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 21,
            "percentage": 0.32
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 10,
            "percentage": 0.15
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 10,
            "percentage": 0.15
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 4,
            "percentage": 0.06
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 3,
            "percentage": 0.05
          }
        ]
      },
      {
        "fips": "53039",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 7,
        "reporting": 7,
        "reportingPercentage": 100,
        "total": 4063,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 1457,
            "percentage": 35.86
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 1481,
            "percentage": 36.45
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 343,
            "percentage": 8.44
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 338,
            "percentage": 8.32
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 202,
            "percentage": 4.97
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 114,
            "percentage": 2.81
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 44,
            "percentage": 1.08
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 38,
            "percentage": 0.94
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 18,
            "percentage": 0.44
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 12,
            "percentage": 0.3
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 5,
            "percentage": 0.12
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 5,
            "percentage": 0.12
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 5,
            "percentage": 0.12
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 1,
            "percentage": 0.02
          }
        ]
      },
      {
        "fips": "53041",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 23,
        "reporting": 20,
        "reportingPercentage": 86.96,
        "total": 9655,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 3443,
            "percentage": 35.66
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 3369,
            "percentage": 34.89
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 1112,
            "percentage": 11.52
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 714,
            "percentage": 7.4
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 482,
            "percentage": 4.99
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 216,
            "percentage": 2.24
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 112,
            "percentage": 1.16
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 83,
            "percentage": 0.86
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 38,
            "percentage": 0.39
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 36,
            "percentage": 0.37
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 20,
            "percentage": 0.21
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 13,
            "percentage": 0.13
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 12,
            "percentage": 0.12
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 5,
            "percentage": 0.05
          }
        ]
      },
      {
        "fips": "53043",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 4,
        "reporting": 3,
        "reportingPercentage": 75,
        "total": 1123,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 405,
            "percentage": 36.06
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 291,
            "percentage": 25.91
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 183,
            "percentage": 16.3
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 82,
            "percentage": 7.3
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 75,
            "percentage": 6.68
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 38,
            "percentage": 3.38
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 24,
            "percentage": 2.14
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 12,
            "percentage": 1.07
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 5,
            "percentage": 0.45
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 4,
            "percentage": 0.36
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 3,
            "percentage": 0.27
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 1,
            "percentage": 0.09
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53045",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 18,
        "reporting": 17,
        "reportingPercentage": 94.44,
        "total": 11720,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 4448,
            "percentage": 37.95
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 3750,
            "percentage": 32
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 1427,
            "percentage": 12.18
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 836,
            "percentage": 7.13
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 615,
            "percentage": 5.25
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 306,
            "percentage": 2.61
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 133,
            "percentage": 1.13
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 72,
            "percentage": 0.61
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 60,
            "percentage": 0.51
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 37,
            "percentage": 0.32
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 19,
            "percentage": 0.16
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 10,
            "percentage": 0.09
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 4,
            "percentage": 0.03
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 3,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53047",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 11,
        "reporting": 10,
        "reportingPercentage": 90.91,
        "total": 5565,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 1877,
            "percentage": 33.73
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2130,
            "percentage": 38.27
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 536,
            "percentage": 9.63
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 520,
            "percentage": 9.34
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 207,
            "percentage": 3.72
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 122,
            "percentage": 2.19
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 60,
            "percentage": 1.08
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 49,
            "percentage": 0.88
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 26,
            "percentage": 0.47
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 17,
            "percentage": 0.31
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 9,
            "percentage": 0.16
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 7,
            "percentage": 0.13
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 3,
            "percentage": 0.05
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 2,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53049",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596596,
        "precincts": 7,
        "reporting": 6,
        "reportingPercentage": 85.71,
        "total": 4664,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 1766,
            "percentage": 37.86
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 1389,
            "percentage": 29.78
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 578,
            "percentage": 12.39
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 395,
            "percentage": 8.47
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 266,
            "percentage": 5.7
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 116,
            "percentage": 2.49
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 46,
            "percentage": 0.99
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 45,
            "percentage": 0.96
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 24,
            "percentage": 0.51
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 17,
            "percentage": 0.36
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 11,
            "percentage": 0.24
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 6,
            "percentage": 0.13
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 4,
            "percentage": 0.09
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 1,
            "percentage": 0.02
          }
        ]
      },
      {
        "fips": "53051",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 4,
        "reporting": 3,
        "reportingPercentage": 75,
        "total": 1736,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 669,
            "percentage": 38.54
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 546,
            "percentage": 31.45
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 206,
            "percentage": 11.87
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 100,
            "percentage": 5.76
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 97,
            "percentage": 5.59
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 42,
            "percentage": 2.42
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 22,
            "percentage": 1.27
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 22,
            "percentage": 1.27
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 13,
            "percentage": 0.75
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 10,
            "percentage": 0.58
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 4,
            "percentage": 0.23
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 2,
            "percentage": 0.12
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 2,
            "percentage": 0.12
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 1,
            "percentage": 0.06
          }
        ]
      },
      {
        "fips": "53053",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 227,
        "reporting": 215,
        "reportingPercentage": 94.71,
        "total": 150392,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 60427,
            "percentage": 40.18
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 53900,
            "percentage": 35.84
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 13283,
            "percentage": 8.83
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 10887,
            "percentage": 7.24
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 5842,
            "percentage": 3.88
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 2479,
            "percentage": 1.65
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 1386,
            "percentage": 0.92
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 681,
            "percentage": 0.45
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 669,
            "percentage": 0.44
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 350,
            "percentage": 0.23
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 231,
            "percentage": 0.15
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 143,
            "percentage": 0.1
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 62,
            "percentage": 0.04
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 52,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53055",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 6,
        "reporting": 5,
        "reportingPercentage": 83.33,
        "total": 6943,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 2489,
            "percentage": 35.85
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2570,
            "percentage": 37.02
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 842,
            "percentage": 12.13
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 404,
            "percentage": 5.82
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 296,
            "percentage": 4.26
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 201,
            "percentage": 2.9
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 75,
            "percentage": 1.08
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 22,
            "percentage": 0.32
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 16,
            "percentage": 0.23
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 13,
            "percentage": 0.19
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 5,
            "percentage": 0.07
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 4,
            "percentage": 0.06
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 3,
            "percentage": 0.04
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 3,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53057",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 35,
        "reporting": 35,
        "reportingPercentage": 100,
        "total": 25123,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 9957,
            "percentage": 39.63
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 8246,
            "percentage": 32.82
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 2336,
            "percentage": 9.3
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 2026,
            "percentage": 8.06
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 1201,
            "percentage": 4.78
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 742,
            "percentage": 2.95
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 265,
            "percentage": 1.05
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 123,
            "percentage": 0.49
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 80,
            "percentage": 0.32
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 68,
            "percentage": 0.27
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 39,
            "percentage": 0.16
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 23,
            "percentage": 0.09
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 9,
            "percentage": 0.04
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 8,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53059",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 4,
        "reporting": 3,
        "reportingPercentage": 75,
        "total": 2004,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 760,
            "percentage": 37.92
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 716,
            "percentage": 35.73
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 183,
            "percentage": 9.13
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 154,
            "percentage": 7.68
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 86,
            "percentage": 4.29
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 55,
            "percentage": 2.74
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 29,
            "percentage": 1.45
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 11,
            "percentage": 0.55
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 6,
            "percentage": 0.3
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 2,
            "percentage": 0.1
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 1,
            "percentage": 0.05
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 1,
            "percentage": 0.05
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53061",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 213,
        "reporting": 213,
        "reportingPercentage": 100,
        "total": 162820,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 64588,
            "percentage": 39.67
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 59453,
            "percentage": 36.51
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 12699,
            "percentage": 7.8
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 12623,
            "percentage": 7.75
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 6570,
            "percentage": 4.04
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 3097,
            "percentage": 1.9
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 1587,
            "percentage": 0.97
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 709,
            "percentage": 0.44
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 661,
            "percentage": 0.41
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 363,
            "percentage": 0.22
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 232,
            "percentage": 0.14
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 111,
            "percentage": 0.07
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 64,
            "percentage": 0.04
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 63,
            "percentage": 0.04
          }
        ]
      },
      {
        "fips": "53063",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 145,
        "reporting": 127,
        "reportingPercentage": 87.59,
        "total": 85030,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 30362,
            "percentage": 35.71
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 29413,
            "percentage": 34.59
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 9857,
            "percentage": 11.59
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 6498,
            "percentage": 7.64
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 4563,
            "percentage": 5.37
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 1995,
            "percentage": 2.35
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 819,
            "percentage": 0.96
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 594,
            "percentage": 0.7
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 389,
            "percentage": 0.46
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 252,
            "percentage": 0.3
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 115,
            "percentage": 0.14
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 104,
            "percentage": 0.12
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 46,
            "percentage": 0.05
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 23,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53065",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 15,
        "reporting": 7,
        "reportingPercentage": 46.67,
        "total": 3373,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 878,
            "percentage": 26.03
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 1011,
            "percentage": 29.97
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 609,
            "percentage": 18.06
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 328,
            "percentage": 9.72
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 271,
            "percentage": 8.03
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 155,
            "percentage": 4.6
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 34,
            "percentage": 1.01
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 25,
            "percentage": 0.74
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 20,
            "percentage": 0.59
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 16,
            "percentage": 0.47
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 10,
            "percentage": 0.3
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 8,
            "percentage": 0.24
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 6,
            "percentage": 0.18
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 2,
            "percentage": 0.06
          }
        ]
      },
      {
        "fips": "53067",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 82,
        "reporting": 80,
        "reportingPercentage": 97.56,
        "total": 64521,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 23034,
            "percentage": 35.7
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 24421,
            "percentage": 37.85
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 6143,
            "percentage": 9.52
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 5046,
            "percentage": 7.82
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 2757,
            "percentage": 4.27
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 1566,
            "percentage": 2.43
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 581,
            "percentage": 0.9
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 347,
            "percentage": 0.54
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 281,
            "percentage": 0.44
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 178,
            "percentage": 0.28
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 76,
            "percentage": 0.12
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 50,
            "percentage": 0.08
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 24,
            "percentage": 0.04
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 17,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53069",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 2,
        "reporting": 1,
        "reportingPercentage": 50,
        "total": 884,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 339,
            "percentage": 38.35
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 280,
            "percentage": 31.67
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 106,
            "percentage": 11.99
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 61,
            "percentage": 6.9
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 49,
            "percentage": 5.54
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 22,
            "percentage": 2.49
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 11,
            "percentage": 1.24
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 7,
            "percentage": 0.79
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 4,
            "percentage": 0.45
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 3,
            "percentage": 0.34
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 1,
            "percentage": 0.11
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 1,
            "percentage": 0.11
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 0,
            "percentage": 0
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53071",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 16,
        "reporting": 15,
        "reportingPercentage": 93.75,
        "total": 8693,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 3411,
            "percentage": 39.24
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2774,
            "percentage": 31.91
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 813,
            "percentage": 9.35
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 789,
            "percentage": 9.08
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 371,
            "percentage": 4.27
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 286,
            "percentage": 3.29
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 100,
            "percentage": 1.15
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 43,
            "percentage": 0.49
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 41,
            "percentage": 0.47
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 33,
            "percentage": 0.38
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 20,
            "percentage": 0.23
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 8,
            "percentage": 0.09
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 4,
            "percentage": 0.05
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53073",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 64,
        "reporting": 59,
        "reportingPercentage": 92.19,
        "total": 58939,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 18684,
            "percentage": 31.7
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 27173,
            "percentage": 46.1
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 5339,
            "percentage": 9.06
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 3174,
            "percentage": 5.39
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 2067,
            "percentage": 3.51
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 1168,
            "percentage": 1.98
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 572,
            "percentage": 0.97
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 254,
            "percentage": 0.43
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 226,
            "percentage": 0.38
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 115,
            "percentage": 0.2
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 61,
            "percentage": 0.1
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 55,
            "percentage": 0.09
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 31,
            "percentage": 0.05
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 20,
            "percentage": 0.03
          }
        ]
      },
      {
        "fips": "53075",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 11,
        "reporting": 10,
        "reportingPercentage": 90.91,
        "total": 6656,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 2011,
            "percentage": 30.21
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 2943,
            "percentage": 44.22
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 718,
            "percentage": 10.79
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 382,
            "percentage": 5.74
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 289,
            "percentage": 4.34
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 143,
            "percentage": 2.15
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 71,
            "percentage": 1.07
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 37,
            "percentage": 0.56
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 36,
            "percentage": 0.54
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 12,
            "percentage": 0.18
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 6,
            "percentage": 0.09
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 5,
            "percentage": 0.08
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 3,
            "percentage": 0.05
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 0,
            "percentage": 0
          }
        ]
      },
      {
        "fips": "53077",
        "id": "49391",
        "party": "Dem",
        "updated": 1584552596597,
        "precincts": 55,
        "reporting": 55,
        "reportingPercentage": 100,
        "total": 23098,
        "candidates": [
          {
            "first": "Joe",
            "last": "Biden",
            "party": "Dem",
            "id": "1036",
            "votes": 8002,
            "percentage": 34.64
          },
          {
            "first": "Bernie",
            "last": "Sanders",
            "party": "Dem",
            "id": "1445",
            "votes": 8763,
            "percentage": 37.94
          },
          {
            "first": "Michael",
            "last": "Bloomberg",
            "party": "Dem",
            "id": "32324",
            "votes": 2904,
            "percentage": 12.57
          },
          {
            "first": "Elizabeth",
            "last": "Warren",
            "party": "Dem",
            "id": "62244",
            "votes": 1303,
            "percentage": 5.64
          },
          {
            "first": "Pete",
            "last": "Buttigieg",
            "party": "Dem",
            "id": "67933",
            "votes": 915,
            "percentage": 3.96
          },
          {
            "first": "Amy",
            "last": "Klobuchar",
            "party": "Dem",
            "id": "51526",
            "votes": 505,
            "percentage": 2.19
          },
          {
            "first": "Tulsi",
            "last": "Gabbard",
            "party": "Dem",
            "id": "62589",
            "votes": 228,
            "percentage": 0.99
          },
          {
            "last": "Uncommitted",
            "party": "Dem",
            "id": "100004",
            "votes": 150,
            "percentage": 0.65
          },
          {
            "first": "Michael",
            "last": "Bennet",
            "party": "Dem",
            "id": "59911",
            "votes": 107,
            "percentage": 0.46
          },
          {
            "first": "Tom",
            "last": "Steyer",
            "party": "Dem",
            "id": "67935",
            "votes": 89,
            "percentage": 0.39
          },
          {
            "first": "Andrew",
            "last": "Yang",
            "party": "Dem",
            "id": "67936",
            "votes": 77,
            "percentage": 0.33
          },
          {
            "first": "Cory",
            "last": "Booker",
            "party": "Dem",
            "id": "63133",
            "votes": 27,
            "percentage": 0.12
          },
          {
            "first": "John",
            "last": "Delaney",
            "party": "Dem",
            "id": "61562",
            "votes": 20,
            "percentage": 0.09
          },
          {
            "first": "Deval",
            "last": "Patrick",
            "party": "Dem",
            "id": "51516",
            "votes": 8,
            "percentage": 0.03
          }
        ]
      }
    ]
  }
]